import { mapState, mapActions } from 'vuex'
// import Sellproductdetails from '../router/views/pharmacy/sellproductdetails.vue'

export const layoutComputed = {
  ...mapState('layout', {
    layoutType: (state) => state.layoutType,
    leftSidebarType: (state) => state.leftSidebarType,
    layoutWidth: (state) => state.layoutWidth,
    topbar: (state) => state.topbar,
    loader: (state) => state.loader
  })
}

export const layoutMethods = mapActions('layout', ['changeLayoutType', 'changeLayoutWidth', 'changeLeftSidebarType', 'changeTopbar', 'changeLoaderValue'])

export const patientComputed = { ...mapState('patients', { patients: (state) => state.patients})}
export const patientMethods = mapActions('patients', ['fetchPatients'])

export const countriesComputed = { ...mapState('countries', {countries: (state) => state.countries })}
export const countriesMethods = mapActions('countries', ['fetchCountries'])

export const visitComputed = { ...mapState('visits', {visits: (state) => state.visits })}
export const visitMethods = mapActions('visits', ['fetchVisits'])

export const insurancevisitComputed = { ...mapState('insurancepatients', {insurancepatients: (state) => state.insurancepatients })}
export const insurancevisitMethods = mapActions('insurancepatients', ['fetchInsuranceVisits'])

export const consultationPatientComputed = { ...mapState('consultationpatients', {consultationpatients: (state) => state.consultationpatients })}
export const consultationPatientMethods = mapActions('consultationpatients', ['fetchConsultationPatients','filterConsultationPatients'])

export const procedurePatientComputed = { ...mapState('procedurepatients', {procedurepatients: (state) => state.procedurepatients })}
export const procedurePatientMethods = mapActions('procedurepatients', ['fetchProcedurePatients','filterProcedurePatients'])

export const dentalPatientComputed = { ...mapState('dentalpatients', {dentalpatients: (state) => state.dentalpatients })}
export const dentalPatientMethods = mapActions('dentalpatients', ['fetchDentalPatients','filterDentalPatients'])

export const antenatalPatientComputed = { ...mapState('antenatalpatients', {antenatalpatients: (state) => state.antenatalpatients })}
export const antenatalPatientMethods = mapActions('antenatalpatients', ['fetchAntenatalPatients','filterAntenatalPatients'])

export const labPatientComputed = { ...mapState('labpatients', {labpatients: (state) => state.labpatients })}
export const labPatientMethods = mapActions('labpatients', ['fetchLabPatients'])

export const radiologyPatientComputed = { ...mapState('radiologypatients', {radiologypatients: (state) => state.radiologypatients })}
export const radiologyPatientMethods = mapActions('radiologypatients', ['fetchRadiologyPatients','filterRadiologyPatients'])

export const otherPatientComputed = { ...mapState('otherpatients', {otherpatients: (state) => state.otherpatients })}
export const otherPatientMethods = mapActions('otherpatients', ['fetchOtherPatients','filterOtherPatients'])

export const theaterPatientComputed = { ...mapState('theaterpatients', {theaterpatients: (state) => state.theaterpatients })}
export const theaterPatientMethods = mapActions('theaterpatients', ['fetchTheaterPatients','filterTheaterPatients'])

export const maternityPatientComputed = { ...mapState('maternitypatients', {maternitypatients: (state) => state.maternitypatients })}
export const maternityPatientMethods = mapActions('maternitypatients', ['fetchMaternityPatients','filterMaternityPatients'])

export const inPatientComputed = { ...mapState('inpatients', {inpatients: (state) => state.inpatients })}
export const inPatientMethods = mapActions('inpatients', ['fetchInPatients'])

export const patienttestresultComputed = { ...mapState('patienttestresults', {patienttestresults: (state) => state.patienttestresults })}
export const patienttestresultMethods = mapActions('patienttestresults', ['fetchPatientTestresults','filterPatientTestResults'])

export const dischargeComputed = { ...mapState('discharges', {discharges: (state) => state.discharges })}
export const dischargeMethods = mapActions('discharges', ['fetchDischarges'])


export const savingComputed = { ...mapState('savings', {savings: (state) => state.savings })}
export const savingMethods = mapActions('savings', ['fetchSavings'])

export const patientbalanceComputed = { ...mapState('patientbalances', {patientbalances: (state) => state.patientbalances })}
export const patientbalanceMethods = mapActions('patientbalances', ['fetchBalances'])

export const patientpaymentComputed = { ...mapState('patientpayments', {patientpayments: (state) => state.patientpayments })}
export const patientpaymentMethods = mapActions('patientpayments', ['fetchPatientPayments','filterPatientPayments'])

export const patientdebtorComputed = { ...mapState('patientdebtors', {patientdebtors: (state) => state.patientdebtors })}
export const patientdebtorMethods = mapActions('patientdebtors', ['fetchDebtors'])

export const referralsComputed = { ...mapState('patientreferrals', {patientreferrals: (state) => state.patientreferrals })}
export const referralsMethods = mapActions('patientreferrals', ['fetchPatientReferrals'])

export const insurancesComputed = { ...mapState('insurancecompanies', {insurancecompanies: (state) => state.insurancecompanies })}
export const insurancesMethods = mapActions('insurancecompanies', ['fetchInsurances'])

export const packagesComputed = { ...mapState('insurancepackages', {insurancepackages: (state) => state.insurancepackages })}
export const packagesMethods = mapActions('insurancepackages', ['fetchInsurancePackages'])

export const dispensemedicineComputed = { ...mapState('dispensemedicines', {dispensemedicines: (state) => state.dispensemedicines })}
export const dispensemedicineMethods = mapActions('dispensemedicines', ['fetchDispenseMedicine'])

export const appointmentComputed = { ...mapState('appointments', {appointments: (state) => state.appointments })}
export const appointmentMethods = mapActions('appointments', ['fetchAppointments'])

export const labsampleComputed = { ...mapState('labsamples', {labsamples: (state) => state.labsamples })}
export const labsampleMethods = mapActions('labsamples', ['fetchLabsamples'])

export const labpatientsampleComputed = { ...mapState('labpatientsamples', {labpatientsamples: (state) => state.labpatientsamples })}
export const labpatientsampleMethods = mapActions('labpatientsamples', ['fetchLabPatientsamples'])

export const expenseCategoryComputed = { ...mapState('expensecategories', {expensecategories: (state) => state.expensecategories })}
export const expenseCategoryMethods = mapActions('expensecategories', ['fetchExpensecategories'])

export const expenseItemComputed = { ...mapState('expenseitems', {expenseitems: (state) => state.expenseitems })}
export const expenseItemMethods = mapActions('expenseitems', ['fetchExpenseitems'])

export const expenseComputed = { ...mapState('expenses', {expenses: (state) => state.expenses })}
export const expenseMethods = mapActions('expenses', ['fetchExpenses'])

export const expensecartComputed = { ...mapState('expensecarts', {expensecarts: (state) => state.expensecarts })}
export const expensecartMethods = mapActions('expensecarts', ['fetchExpenseCart'])

export const userComputed = { ...mapState('users', {users: (state) => state.users })}
export const userMethods = mapActions('users', ['fetchUsers'])

export const roleComputed = { ...mapState('roles', {roles: (state) => state.roles })}
export const roleMethods = mapActions('roles', ['fetchRoles'])

export const auditComputed = { ...mapState('audits', {audits: (state) => state.audits })}
export const auditMethods = mapActions('audits', ['fetchAudits','filterAudits'])

export const permissionComputed = { ...mapState('permissions', {permissions: (state) => state.permissions })}
export const permissionMethods = mapActions('permissions', ['fetchPermissions'])

export const paymentoptionComputed = { ...mapState('paymentoptions', {paymentoptions: (state) => state.paymentoptions })}
export const paymentoptionMethods = mapActions('paymentoptions', ['fetchPaymentoptions'])

export const productcategoryComputed = { ...mapState('productcategories', {productcategories: (state) => state.productcategories })}
export const productcategoryMethods = mapActions('productcategories', ['fetchCategories'])

export const unitsComputed = { ...mapState('productunits', {productunits: (state) => state.productunits })}
export const unitsMethods = mapActions('productunits', ['fetchUnits'])

export const itemunitsComputed = { ...mapState('productitemunits', {productitemunits: (state) => state.productitemunits })}
export const itemunitsMethods = mapActions('productitemunits', ['fetchItemUnits'])

export const productComputed = { ...mapState('products', {products: (state) => state.products })}
export const productMethods = mapActions('products', ['fetchProducts'])

export const purchasecartComputed = { ...mapState('purchasecarts', {purchasecarts: (state) => state.purchasecarts })}
export const purchasecartMethods = mapActions('purchasecarts', ['fetchPurchaseCart'])

export const salecartComputed = { ...mapState('salecarts', {salecarts: (state) => state.salecarts })}
export const salecartMethods = mapActions('salecarts', ['fetchSalesCart'])

export const stocklevelComputed = { ...mapState('stocklevels', {stocklevels: (state) => state.stocklevels })}
export const stocklevelMethods = mapActions('stocklevels', ['fetchStocklevels'])

export const supplierComputed = { ...mapState('suppliers', {suppliers: (state) => state.suppliers })}
export const supplierMethods = mapActions('suppliers', ['fetchSuppliers'])

export const serviceComputed = { ...mapState('services', {services: (state) => state.services })}
export const serviceMethods = mapActions('services', ['fetchServices'])

export const labserviceComputed = { ...mapState('labservices', {labservices: (state) => state.labservices })}
export const labserviceMethods = mapActions('labservices', ['fetchLabServices'])

export const testresultComputed = { ...mapState('testresults', {testresults: (state) => state.testresults })}
export const testresultMethods = mapActions('testresults', ['fetchTestResults',])

export const serviceCategoryComputed = { ...mapState('servicecategories', {servicecategories: (state) => state.servicecategories })}
export const serviceCategoryMethods = mapActions('servicecategories', ['fetchServiceCategory'])

export const smsBundleComputed = { ...mapState('smsbundles', {smsbundles: (state) => state.smsbundles })}
export const smsBundleMethods = mapActions('smsbundles', ['fetchSmsBundles'])

export const smsPurchasesComputed = { ...mapState('smspurchases', {smspurchases: (state) => state.smspurchases })}
export const smsPurchasesMethods = mapActions('smspurchases', ['fetchSmsPurchases'])

export const reportpaymentsbyoptionComputed = { ...mapState('reportpaymentsbyoptions', {reportpaymentsbyoptions: (state) => state.reportpaymentsbyoptions })}
export const reportpaymentsbyoptionMethods = mapActions('reportpaymentsbyoptions', ['fetchReportPaymentsbyOptions','filterReportPaymentsbyOptions'])

export const reportpaymentsbymonthComputed = { ...mapState('reportpaymentsbymonths', {reportpaymentsbymonths: (state) => state.reportpaymentsbymonths })}
export const reportpaymentsbymonthMethods = mapActions('reportpaymentsbymonths', ['fetchReportPaymentsbyMonths','filterReportPaymentsbyMonths'])

export const reportserviceanalysisComputed = { ...mapState('reportserviceanalysis', {reportserviceanalysis: (state) => state.reportserviceanalysis })}
export const reportserviceanalysisMethods = mapActions('reportserviceanalysis', ['fetchReportServiceAnalysis','filterReportServiceAnalysis'])

export const reportdiagnosisanalysisComputed = { ...mapState('reportdiagnosisanalysis', {reportdiagnosisanalysis: (state) => state.reportdiagnosisanalysis })}
export const reportdiagnosisanalysisMethods = mapActions('reportdiagnosisanalysis', ['fetchReportDiagnosisAnalysis','filterReportDiagnosisAnalysis'])

export const reportdepartmentanalysisComputed = { ...mapState('reportdepartmentanalysis', {reportdepartmentanalysis: (state) => state.reportdepartmentanalysis })}
export const reportdepartmentanalysisMethods = mapActions('reportdepartmentanalysis', ['fetchReportDepartmentAnalysis','filterReportDepartmentAnalysis'])

export const reportproductsdemandComputed = { ...mapState('reportproductsdemands', {reportproductsdemands: (state) => state.reportproductsdemands })}
export const reportproductsdemandMethods = mapActions('reportproductsdemands', ['fetchReportProductsDemand','filterReportProductsDemand'])

export const reportcashpaymentsComputed = { ...mapState('reportcashpayments', {reportcashpayments: (state) => state.reportcashpayments })}
export const reportcashpaymentsMethods = mapActions('reportcashpayments', ['fetchReportCashPayments','filterReportCashPayments'])

export const reportpersonalpaymentsComputed = { ...mapState('reportpersonalpayments', {reportpersonalpayments: (state) => state.reportpersonalpayments })}
export const reportpersonalpaymentsMethods = mapActions('reportpersonalpayments', ['fetchReportPersonalPayments','filterReportPersonalPayments'])

export const reportpharmacypaymentsComputed = { ...mapState('reportpharmacypayments', {reportpharmacypayments: (state) => state.reportpharmacypayments })}
export const reportpharmacypaymentsMethods = mapActions('reportpharmacypayments', ['fetchReportPharmacyPayments','filterReportPharmacyPayments'])

export const selldetailsComputed = { ...mapState('sellproductdetails', {sellproductdetails: (state) => state.sellproductdetails })}
export const selldetailsMethods = mapActions('sellproductdetails', ['fetchSellProductDetails'])

export const reportpharmacybymonthComputed = { ...mapState('reportpharmacybymonths', {reportpharmacybymonths: (state) => state.reportpharmacybymonths })}
export const reportpharmacybymonthMethods = mapActions('reportpharmacybymonths', ['fetchReportPharmacybyMonths','filterReportPharmacybyMonths'])

export const reportpharmacypurchasesComputed = { ...mapState('reportpharmacypurchases', {reportpharmacypurchases: (state) => state.reportpharmacypurchases })}
export const reportpharmacypurchasesMethods = mapActions('reportpharmacypurchases', ['fetchReportPharmacyPurchases','filterReportPharmacyPurchases'])

export const reportpurchasesbysupplierComputed = { ...mapState('reportpurchasesbysupplier', {reportpurchasesbysupplier: (state) => state.reportpurchasesbysupplier })}
export const reportpurchasesbysupplierMethods = mapActions('reportpurchasesbysupplier', ['fetchReportPurchasesbySupplier','filterReportPurchasesbySupplier'])

export const reportpaymentsbyuserComputed = { ...mapState('reportpaymentsbyuser', {reportpaymentsbyuser: (state) => state.reportpaymentsbyuser })}
export const reportpaymentsbyuserMethods = mapActions('reportpaymentsbyuser', ['fetchReportPaymentsbyUser','filterReportPaymentsbyUser'])

export const reportworkloadbyuserComputed = { ...mapState('reportworkloadbyuser', {reportworkloadbyuser: (state) => state.reportworkloadbyuser })}
export const reportworkloadbyuserMethods = mapActions('reportworkloadbyuser', ['fetchReportWorkloadbyUser','filterReportWorkloadbyUser'])

export const reportlabComputed = { ...mapState('reportlabs', {reportlabs: (state) => state.reportlabs })}
export const reportlabMethods = mapActions('reportlabs', ['fetchReportLab','filterReportLab'])

export const reportappointmentComputed = { ...mapState('reportappointments', {reportappointments: (state) => state.reportappointments })}
export const reportappointmentMethods = mapActions('reportappointments', ['fetchReportAppointment','filterReportAppointment'])

export const reportexpenseComputed = { ...mapState('reportexpenses', {reportexpenses: (state) => state.reportexpenses })}
export const reportexpenseMethods = mapActions('reportexpenses', ['fetchReportExpense','filterReportExpense'])

export const reportexpensecategoryComputed = { ...mapState('reportexpensescategory', {reportexpensescategory: (state) => state.reportexpensescategory })}
export const reportexpensecategoryMethods = mapActions('reportexpensescategory', ['fetchReportExpenseCategory','filterReportExpenseCategory'])

export const reportcashflowComputed = { ...mapState('reportcashflows', {reportcashflows: (state) => state.reportcashflows })}
export const reportcashflowMethods = mapActions('reportcashflows', ['fetchReportCashflow','filterReportCashflow'])

export const reportcashflowsbymonthComputed = { ...mapState('reportcashflowsbymonths', {reportcashflowsbymonths: (state) => state.reportcashflowsbymonths })}
export const reportcashflowsbymonthMethods = mapActions('reportcashflowsbymonths', ['fetchReportCashflowbyMonths','filterReportCashflowbyMonths'])

export const profileComputed = { ...mapState('profiles', {profiles: (state) => state.profiles })}
export const profileMethods = mapActions('profiles', ['fetchProfile'])

export const groupaccountComputed = { ...mapState('groupaccounts', {groupaccounts: (state) => state.groupaccounts })}
export const groupaccountMethods = mapActions('groupaccounts', ['fetchGroupAccounts'])

export const groupaccountmemberComputed = { ...mapState('groupaccountmembers', {groupaccountmembers: (state) => state.groupaccountmembers })}
export const groupaccountmemberMethods = mapActions('groupaccountmembers', ['fetchGroupAccountMembers'])

export const groupaccountinvoiceComputed = { ...mapState('groupaccountinvoices', {groupaccountinvoices: (state) => state.groupaccountinvoices })}
export const groupaccountinvoiceMethods = mapActions('groupaccountinvoices', ['fetchGroupAccountInvoices','filterGroupAccountInvoices'])

export const insuranceinvoiceComputed = { ...mapState('insuranceinvoices', {insuranceinvoices: (state) => state.insuranceinvoices })}
export const insuranceinvoiceMethods = mapActions('insuranceinvoices', ['fetchInsuranceInvoices','filterInsuranceInvoices'])

export const insuranceledgerComputed = { ...mapState('insuranceledgers', {insuranceledgers: (state) => state.insuranceledgers })}
export const insuranceledgerMethods = mapActions('insuranceledgers', ['fetchInsuranceLedgers','filterInsuranceLedgers'])

export const birthcertificateComputed = { ...mapState('birthcertificates', {birthcertificates: (state) => state.birthcertificates })}
export const birthcertificateMethods = mapActions('birthcertificates', ['fetchBirthCertificates'])

export const patientconsentformComputed = { ...mapState('patientconsentforms', {patientconsentforms: (state) => state.patientconsentforms })}
export const patientconsentformMethods = mapActions('patientconsentforms', ['fetchPatientConsentForms'])

export const subscriptionComputed = { ...mapState('subscriptions', {subscriptions: (state) => state.subscriptions })}
export const subscriptionMethods = mapActions('subscriptions', ['fetchSubscriptions'])

export const deathcertificateComputed = { ...mapState('deathcertificates', {deathcertificates: (state) => state.deathcertificates })}
export const deathcertificateMethods = mapActions('deathcertificates', ['fetchDeathCertificates'])

export const notificationComputed = { ...mapState('notifications', {notifications: (state) => state.notifications })}
export const notificationMethods = mapActions('notifications', ['fetchNotifications'])

export const diseaseComputed = { ...mapState('diseases', {diseases: (state) => state.diseases })}
export const diseaseMethods = mapActions('diseases', ['fetchDiseases'])

export const specialtiesComputed = { ...mapState('specialties', {specialties: (state) => state.specialties })}
export const specialtiesMethods = mapActions('specialties', ['fetchSpecialties'])


export const doctorSpecialtyComputed = { ...mapState('doctorspecialty', {doctorspecialty: (state) => state.doctorspecialty })}
export const doctorSpecialtyMethods = mapActions('doctorspecialty', ['fetchDoctorspecialty'])

export const specialisationComputed = { ...mapState('specialisation', {specialisation: (state) => state.specialisation })}
export const specialisationMethods = mapActions('specialisation', ['fetchSpecialisation'])


export const schedulesComputed = { ...mapState('schedules', {schedules: (state) => state.schedules })}
export const schedulesMethods = mapActions('schedules', ['fetchSchedules'])

export const appbookingsComputed = { ...mapState('appbookings', {appbookings: (state) => state.appbookings })}
export const appbookingsMethods = mapActions('appbookings', ['fetchAppBookings'])

export const drugsComputed = { ...mapState('drugs', {drugs: (state) => state.drugs })}
export const drugsMethods = mapActions('drugs', ['fetchDrugs'])

export const appuserComputed = { ...mapState('appusers', { appusers: (state) => state.appusers})}
export const appuserMethods = mapActions('appusers', ['fetchAppUsers'])
